module.exports = __webpack_public_path__ + "assets/img/returnBtn-47c22d84.png";